import axios from 'axios'
import fn from '../../utils/functions'
import FileSaver from 'file-saver'
import qs from 'qs'
import dayjs from 'dayjs';

// Normaliza fechas en profundidad para evitar que qs.stringify destruya objetos Dayjs
export function convertDates(obj) {
  if (obj == null) return obj;

  // Detecta Day.js correctamente
  if (dayjs.isDayjs(obj)) {
    return obj.toISOString();
  }

  // Detecta Date nativo
  if (obj instanceof Date) {
    return obj.toISOString();
  }

  // Arrays → recorrer
  if (Array.isArray(obj)) {
    return obj.map(item => convertDates(item));
  }

  // Objetos → recorrer recursivamente
  if (typeof obj === 'object') {
    const newObj = {};
    for (const key in obj) {
      newObj[key] = convertDates(obj[key]);
    }
    return newObj;
  }

  
  return obj;
}

function initSession () {
  const session = {
    // Centros
    centres: {
      tableData: [],
      totalCentres: 0
    },
    queryCentres: {
      page: 0,
      size: 20,
      sort: 'description,ASC',
      creationDateTimeFrom: fn.initDateFrom(3),
      creationDateTimeTo: fn.initDateTo()
    },
    listSelectedFiltersCentres: [],
    // Datos Select Filtros Centros
    optionsFilterCentresName: [],
    optionsFilterCentresGln: [],
    optionsFilterCentresProvince: [],
    optionsFilterCentresCode: [],
    optionsFilterCentresMailbox: [],
    optionsFilterCentresType: [],
    optionsFilterCountriesEnabled: []
  }
  return session
}
function initLocal () {
  const local = {

    // Columnas Tabla Centros
    isShowNameCentre: true,
    isShowCreationDateTimeCentre: true,
    isShowCodeCentre: true,
    isShowGlnCentre: true,
    isShowTownCentre: true,
    isShowProvinceCentre: true,
    isShowCountryCentre: true
  }
  return local
}
function setByUserLocalCentre () {
  const local = {
    // Columnas Tabla Centros
    isShowNameCentre: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).centros.isShowNameCentre,
    isShowCreationDateTimeCentre: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).centros.isShowCreationDateTimeCentre,
    isShowCodeCentre: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).centros.isShowCodeCentre,
    isShowGlnCentre: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).centros.isShowGlnCentre,
    isShowTownCentre: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).centros.isShowTownCentre,
    isShowProvinceCentre: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).centros.isShowProvinceCentre,
    isShowCountryCentre: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).centros.isShowCountryCentre
  }
  return local
}
// state
const state = {
  userConfigLocalStorage: '',
  local: {

    // Columnas Tabla Centros
    isShowNameCentre: true,
    isShowCreationDateTimeCentre: true,
    isShowCodeCentre: true,
    isShowGlnCentre: true,
    isShowTownCentre: true,
    isShowProvinceCentre: true,
    isShowCountryCentre: true
  },
  session: initSession()
}

// getters
const getters = {
  // Datos Tabla Usuarios
  centres: state => {
    return state.session.centres
  },
  queryCentres: state => {
    return state.session.queryCentres
  },
  listSelectedFiltersCentres: state => {
    return state.session.listSelectedFiltersCentres
  },

  // Datos Select Filtros Usuarios
  optionsFilterCentresName: state => {
    return state.session.optionsFilterCentresName
  },
  optionsFilterCentresGln: state => {
    return state.session.optionsFilterCentresGln
  },
  optionsFilterCentresProvince: state => {
    return state.session.optionsFilterCentresProvince
  },
  optionsFilterCentresCode: state => {
    return state.session.optionsFilterCentresCode
  },
  optionsFilterCentresMailbox: state => {
    return state.session.optionsFilterCentresMailbox
  },
  optionsFilterCentresType: state => {
    return state.session.optionsFilterCentresType
  },
  optionsFilterCountriesEnabled: state => {
    return state.session.optionsFilterCountriesEnabled
  },

  // Columnas Tabla Centros

  isShowNameCentre: state => {
    return state.local.isShowNameCentre
  },
  isShowCreationDateTimeCentre: state => {
    return state.local.isShowCreationDateTimeCentre
  },
  isShowCodeCentre: state => {
    return state.local.isShowCodeCentre
  },
  isShowGlnCentre: state => {
    return state.local.isShowGlnCentre
  },
  isShowTownCentre: state => {
    return state.local.isShowTownCentre
  },
  isShowProvinceCentre: state => {
    return state.local.isShowProvinceCentre
  },
  isShowCountryCentre: state => {
    return state.local.isShowCountryCentre
  }
}

// actions
const actions = {
  // Crear key Usuario
  setUserNameCentre ({ state }) {
    // Manda el username a las computadas para su comprobacion en el storage
    const B2bUserConfigSession = JSON.parse(sessionStorage.getItem('store'))
    state.userConfigLocalStorage = B2bUserConfigSession.activeUser.data.username
    if (JSON.parse(localStorage.getItem(state.userConfigLocalStorage))) {
      state.local = setByUserLocalCentre()
    }
  },

  isNewVersionCentrosLocalState ({ state }, localStorage) {
    return fn.isNewVersion(state, localStorage.centros)
  },

  // METODOS
  // Búsqueda de centros
  async getCentresByPartyCentres ({ commit, rootState }, data) {
    try {
      data.query.urlName = null
      if (rootState.session.urlIn !== null && rootState.session.urlIn !== undefined &&
        rootState.session.urlIn !== 'b2b') {
        data.query.urlName = rootState.session.urlIn
      }
      const response = await axios({
        method: 'GET',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        url: '/centre',
        params: data.query
      })

      commit('CENTRES_STATE', {
        tableData: response.data.content,
        totalCentres: response.data.totalElements
      })

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  /*
    * Servicio para exportar el listado de centros en formato CSV
    */
  async downloadCentresCsv ({
    commit, rootState
  }, params) {
    try {
      const response = await axios({
        method: 'GET',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        // baseURL: 'http://localhost:8084/edocs-rest/rest-api/v1',
        url: '/centre/export',
        params: params,
        headers: { 'Accept-Language': params.activeLang },
        responseType: 'blob',
        paramsSerializer: params => {
          return qs.stringify(convertDates(params), { indices: false})
        }
      })
      console.log('RESPONSE downloadCentresCsv:: ', response)
      fn.assignJwt(commit, rootState.jwt, response.headers.authorization)

      const blob = new Blob([response.data], {
        type: response.headers['content-type']
      })

      const filename = fn.extractFilename(response.headers['content-disposition'], 'all-csv-centres.pdf')
      FileSaver.saveAs(blob, filename)
      return (filename)
    } catch (error) {
      console.log('downloadCentresCsv: ', error)
      throw error
    }
  },

  /*
    * Servicio para exportar en formato CSV los flujos y niveles de aprobación de centros
    */
  async downloadCentreApprovalFlowCsv ({
    commit, rootState
  }, params) {
    try {
      const response = await axios({
        method: 'GET',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        // baseURL: 'http://localhost:8084/edocs-rest/rest-api/v1',
        url: '/approval/export',
        params: params,
        headers: { 'Accept-Language': params.activeLang },
        responseType: 'blob',
        paramsSerializer: params => {
          return qs.stringify(convertDates(params), { indices: false})
        }
      })
      console.log('RESPONSE downloadCentreApprovalFlowCsv:: ', response)
      fn.assignJwt(commit, rootState.jwt, response.headers.authorization)

      const blob = new Blob([response.data], {
        type: response.headers['content-type']
      })

      const filename = fn.extractFilename(response.headers['content-disposition'], 'all-csv-centre-approval-flow.pdf')
      FileSaver.saveAs(blob, filename)
      return (filename)
    } catch (error) {
      console.log('downloadCentreApprovalFlowCsv: ', error)
      throw error
    }
  },

  // Servicio para traer detalle de un centro
  async getCentreById ({ commit, rootState }, data) {
    try {
      const response = await axios({
        method: 'GET',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        url: '/centre/' + data.centreId,
        params: data
      })

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },
  /**
     * Servicio para llenar Combo Centros de Comprador para Tareas pendientes
     * /protocol
     */
  async getComboBuyerCenter ({ commit, rootState }, data) {
    try {
      const response = await axios({
        method: 'GET',
        url: '/centre/comboBuyerCentre/' + data.invoiceId,
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
      })

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },
  // Servicio para actualizar el detalle de un centro
  async uploadInformationCentre ({ commit, rootState }, centreUpdate) {
    try {
      console.log('data: ', centreUpdate)
      const response = await axios({
        method: 'PUT',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        url: '/centre/' + centreUpdate.code,
        data: centreUpdate
      })

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  /* Modifica  el estado de un centro(Habilita/Deshabilita) */
  async updateStatusCentre ({ commit, rootState }, request) {
    try {
      const response = await axios({
        method: 'PUT',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        url: '/centre/' + request.partyId + '/enable',
        params: {
          enable: request.enable
        }
      })

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  async updatePermanentEstablishmentCentre ({ commit, rootState }, request) {
    try {
      const response = await axios({
        method: 'PUT',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        url: '/centre/' + request.partyId + '/permanentEstablishment',
        params: {
          permanentEstablishment: request.permanentEstablishment
        }
      })

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  /* Modifica un  centro */
  async modifyCentre ({ commit, rootState }, { centreId, params }) {
    try {
      const response = await axios({
        method: 'PUT',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        url: '/centre/' + centreId,
        data: params
      })

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  // Inserta un  centro nuevo
  async insertCentre ({ commit, rootState }, { params }) {
    try {
      const response = await axios({
        method: 'POST',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        url: '/centre',
        data: params
      })

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  // Datos de CentreMedia
  async getCentreMedia ({ commit, rootState }, params) {
    try {
      const response = await axios({
        method: 'GET',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        url: '/centre/' + params.centreId + '/centremedia'
      })

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  // Elimina un dato de contacto
  async deleteCentreMedia ({ commit, rootState }, params) {
    try {
      const response = await axios({
        method: 'DELETE',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        url: '/centre/' + params.centreId + '/centremedia/' + params.centremediaId
      })

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },
  /* Agrega un centremedia */
  async insertCentreMedia ({ commit, rootState }, params) {
    try {
      const response = await axios({
        method: 'POST',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        url: '/centre/' + params.centreId + '/centremedia',
        data: {
          proyectId: params.projectId,
          mediaTypeId: params.mediaTypeId,
          documentTypeId: params.documentTypeId,
          value: params.value,
          centreType: params.centreType
        }
      })

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  // GET Datos del flujo de aprobación del centro en centre_approval_amount
  async getCentreApprovalAmount ({ commit, rootState }, params) {
    try {
      const response = await axios({
        method: 'GET',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        url: '/approval/' + params.centreId
      })
      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  // GET Datos del flujo de aprobación del centro en centre_approval_amount
  async getCentreApprovalAmountById ({ commit, rootState }, params) {
    try {
      const response = await axios({
        method: 'GET',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        url: '/approval/flow/' + params.centreApprovalAmountId,
        params: {
          centreId: params.centreId
        }
      })
      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },
  // Agrega o actualiza el flujo de aprobación de un centro en centre_approval_amount
  async insertOrUpdateCentreApprovalAmount ({ commit, rootState }, params) {
    try {
      const response = await axios({
        method: 'POST',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        url: '/approval/' + params.centreId + '/approvalflow',
        data: {
          proyectId: params.projectId,
          centreId: params.centreId,
          amountFrom: params.amountFrom,
          amountTo: params.amountTo,
          description: params.description,
          id: params.id,
          purchaseOrder: params.purchaseOrder,
        }
      })
      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },
  // Elimina un flujo de aprobción de un centro en centre_approval_amount
  async deleteCentreApprovalAmount ({ commit, rootState }, params) {
    try {
      const response = await axios({
        method: 'DELETE',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        url: '/approval/' + params.centreApprovalAmountId + '/project/' + params.projectId,
        params:{
          centreId: params.centreId
        }

      })

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },
  // GET niveles de aprobación de centre_approval_level
  async getCentreApprovalLevel ({ commit, rootState }, params) {
    try {
      const response = await axios({
        method: 'GET',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        url: '/approval/' + params.centreApprovalAmountId + '/levels',
        params: {
          centreId: params.centreId
        }
      })
      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },
  // Agrega un nivel de aprobación en centre_approval_level
  async insertCentreApprovalLevel ({ commit, rootState }, params) {
    try {
      const response = await axios({
        method: 'POST',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        url: '/approval/' + params.centreApprovalAmountId + '/level',
        data: {
          proyectId: params.projectId,
          centreId: params.centreId,
          level: params.level,
          userId: params.userId,
          notification: params.notification
        }
      })
      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },
  // Elimina un nivel de aprobación en centre_approval_level
  async deleteCentreApprovalLevel ({ commit, rootState }, params) {
    try {
      const response = await axios({
        method: 'DELETE',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        url: '/approval/' + params.centreId + '/project/' + params.projectId + '/level/' + params.levelId
      })

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },
  // Obtiene el listado de usuarios que pueden ser seleccionados como aprobadores de un nivel de aprobación
  async getUsersForApprovalLevel ({ commit, rootState }, params) {
    try {
      const response = await axios({
        method: 'GET',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        url: '/approval/users/' + params.projectId + '/' + params.partyId + '/' + params.centreId
      })
      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  /* Obtienes los roles de un centro */
  async getCentreRoleTypeCode ({ commit, rootState }, params) {
    try {
      const response = await axios({
        method: 'GET',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        url: '/centre/' + params.idCentre + '/centrerole',
        params: {
          isBuyer: params.isBuyer,
          isDraft: params.isDraft
        }
      })

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      if (response.data !== 'undefined' && response.data !== null) {
        return response.data
      }
      return []
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  /* Agrega un centre role type code */
  async insertCentreRoleTypeCode ({ commit, rootState }, params) {
    try {
      const response = await axios({
        method: 'POST',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        url: '/centre/' + params.centreId + '/centrerole',
        data: {
          proyectId: params.projectId,
          centreRoleTypeId: params.roleTypeId,
        }
      })

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

    /* Elimina un centre role type code */
    async deleteCentreRoleTypeCode ({ commit, rootState }, params) {
      try {
        const response = await axios({
          method: 'DELETE',
          baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
          url: '/centre/' + params.centreId + '/centrerole/' + params.centreRoleTypeCodeId,
          params: {
            projectId: params.projectId,
          }
        })
  
        fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
        return response
      } catch (error) {
        console.log('ERROR --- ', error.response)
        throw error.response
      }
    },
  // Proyectos que pertenecen a una empresa
  async getProjectsByParty ({ commit, rootState }, partyId) {
    try {
      const response = await axios({
        method: 'GET',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        url: '/me/projects/' + partyId + '/party'
      })

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  // Servicio para eliminar un centro
  async deleteCentreProjectParties ({ commit, rootState }, centreId) {
    try {
      const response = await axios({
        method: 'DELETE',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        url: '/centre/' + centreId
      })

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  // Datos Tabla centros
  centresState: ({ commit }, payload) => {
    commit('CENTRES_STATE', payload)
  },
  queryCentresState: ({ commit }, payload) => {
    commit('QUERY_CENTRES_STATE', payload)
  },
  listSelectedFiltersCentresState: ({ commit }, payload) => {
    commit('LIST_SELECTED_FILTERS_CENTRES_STATE', payload)
  },

  // Datos Select Filtros Centros
  optionsFilterCentresNameState: ({ commit }, payload) => {
    commit('OPTIONS_FILTER_CENTRES_NAME', payload)
  },
  optionsFilterCentresGlnState: ({ commit }, payload) => {
    commit('OPTIONS_FILTER_CENTRES_GLN', payload)
  },
  optionsFilterCentresProvinceState: ({ commit }, payload) => {
    commit('OPTIONS_FILTER_CENTRES_PROVINCE', payload)
  },
  optionsFilterCentresCodeState: ({ commit }, payload) => {
    commit('OPTIONS_FILTER_CENTRES_CODE', payload)
  },
  optionsFilterCentresMailboxState: ({ commit }, payload) => {
    commit('OPTIONS_FILTER_CENTRES_MAILBOX', payload)
  },
  optionsFilterCentresTypeState: ({ commit }, payload) => {
    commit('OPTIONS_FILTER_CENTRES_TYPE', payload)
  },
  optionsFilterCountriesEnabled: ({ commit }, payload) => {
    commit('OPTIONS_FILTER_COUNTRIESENABLED_STATE', payload)
  },

  // Columnas Tabla Centros
  isShowNameCentreAction: ({ commit }, payload) => {
    commit('IS_SHOW_NAME_CENTRE', payload)
  },
  isShowCreationDateTimeCentreAction: ({ commit }, payload) => {
    commit('IS_SHOW_DATE_CENTRE', payload)
  },
  isShowCodeCentreAction: ({ commit }, payload) => {
    commit('IS_SHOW_CODE_CENTRE', payload)
  },
  isShowGlnCentreAction: ({ commit }, payload) => {
    commit('IS_SHOW_GLN_CENTRE', payload)
  },
  isShowTownCentreAction: ({ commit }, payload) => {
    commit('IS_SHOW_TOWN_CENTRE', payload)
  },
  isShowProvinceCentreAction: ({ commit }, payload) => {
    commit('IS_SHOW_PROVINCE_CENTRE', payload)
  },
  isShowCountryCentreAction: ({ commit }, payload) => {
    commit('IS_SHOW_COUNTRY_CENTRE', payload)
  }
}

// mutations
const mutations = {
  resetSessionCentros (state) {
    state.session = initSession()
    state.local = initLocal()
  },
  // Funcion para definir el filtro rápido de fechas cuando se es superadmin
  centresDatesSuperAdmin (state) {
    state.session.queryCentres.creationDateTimeFrom = fn.initDateFrom(1)
  },
  // Centros
  'CENTRES_STATE' (state, payload) {
    state.session.centres = payload
  },
  'QUERY_CENTRES_STATE' (state, payload) {
    state.session.queryCentres = payload
  },
  'LIST_SELECTED_FILTERS_CENTRES_STATE' (state, payload) {
    state.session.listSelectedFiltersCentres = payload
  },

  // Datos Select Filtros Centros
  'OPTIONS_FILTER_CENTRES_NAME' (state, payload) {
    state.session.optionsFilterCentresName = payload
  },
  'OPTIONS_FILTER_CENTRES_GLN' (state, payload) {
    state.session.optionsFilterCentresGln = payload
  },
  'OPTIONS_FILTER_CENTRES_PROVINCE' (state, payload) {
    state.session.optionsFilterCentresProvince = payload
  },
  'OPTIONS_FILTER_CENTRES_CODE' (state, payload) {
    state.session.optionsFilterCentresCode = payload
  },
  'OPTIONS_FILTER_CENTRES_MAILBOX' (state, payload) {
    state.session.optionsFilterCentresMailbox = payload
  },
  'OPTIONS_FILTER_CENTRES_TYPE' (state, payload) {
    state.session.optionsFilterCentresType = payload
  },
  'OPTIONS_FILTER_COUNTRIESENABLED_STATE' (state, payload) {
    state.session.optionsFilterCountriesEnabled = payload
  },

  // Columnas Tabla Centros
  'IS_SHOW_NAME_CENTRE' (state, payload) {
    state.local.isShowNameCentre = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.centros.isShowNameCentre = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_DATE_CENTRE' (state, payload) {
    state.local.isShowCreationDateTimeCentre = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.centros.isShowCreationDateTimeCentre = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_CODE_CENTRE' (state, payload) {
    state.local.isShowCodeCentre = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.centros.isShowCodeCentre = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_GLN_CENTRE' (state, payload) {
    state.local.isShowGlnCentre = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.centros.isShowGlnCentre = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_TOWN_CENTRE' (state, payload) {
    state.local.isShowTownCentre = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.centros.isShowTownCentre = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_PROVINCE_CENTRE' (state, payload) {
    state.local.isShowProvinceCentre = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.centros.isShowProvinceCentre = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_COUNTRY_CENTRE' (state, payload) {
    state.local.isShowCountryCentre = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.centros.isShowCountryCentre = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
